import { render } from "./msgCenter.vue?vue&type=template&id=6e8de5f5&scoped=true"
import script from "./msgCenter.vue?vue&type=script&lang=js"
export * from "./msgCenter.vue?vue&type=script&lang=js"

import "./msgCenter.vue?vue&type=style&index=0&id=6e8de5f5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8de5f5"]])

export default __exports__